import React, { useEffect, useState } from 'react';
import { V3KYCMobilePages as Pages } from 'spa/constants/VerificationConstants';
import MobilePage from '../../components/MobilePage';
import UploadSuccess from '../../components/UploadSuccess';

const POAUploadSuccessPage = () => {
  const [nextPageTrigger, setNextPageTrigger] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setNextPageTrigger(true);
    }, 1500);
  }, []);

  // TODO T297643: Update the copy for uploadedText
  return (
    <MobilePage nextPage={Pages.SELFIE_INSTRUCTIONS} nextPageTrigger={nextPageTrigger} noButton>
      <UploadSuccess uploadedText={'Upload successful'} />
    </MobilePage>
  );
};

export default POAUploadSuccessPage;
